import { sub, format, parse } from 'date-fns'
import { ROLLING_DATE_OPTIONS, isRollingDateValue } from '../schemas/filter-entity'
import { getExchangeToday } from '@/lib/exchange-time'

/**
 * Resolve a rolling date key (e.g. 'rolling_90_days') to a concrete YYYY-MM-DD
 * date string relative to today in exchange time (ET).
 */
export function resolveRollingDate(key: string): string {
  const opt = ROLLING_DATE_OPTIONS.find((o) => o.key === key)
  if (!opt) return key // Unknown key — pass through

  const now = parse(getExchangeToday(), 'yyyy-MM-dd', new Date())
  const resolved = sub(now, { [opt.unit]: opt.value })
  return format(resolved, 'yyyy-MM-dd')
}

/**
 * If the value is a rolling date key, resolve it. Otherwise, return as-is.
 */
export function maybeResolveRollingValue(value: unknown): unknown {
  if (isRollingDateValue(value)) {
    return resolveRollingDate(value as string)
  }
  return value
}

/**
 * Resolve a `[low, high]` window. A rolling low ("1 Year") means "ending today",
 * so its high is today whatever is stored: every writer saved the day it was
 * clicked as the high, which froze the window on reload. Two fixed dates pass
 * through unchanged.
 */
export function resolveRollingRange(low: unknown, high: unknown): [unknown, unknown] {
  if (isRollingDateValue(low)) return [resolveRollingDate(low), getExchangeToday()]
  return [low, maybeResolveRollingValue(high)]
}
